// Chart section management actions
export const sectionActions = (set, get) => ({
  setSectionOrder: (chartId, sectionOrder) => {
    set((state) => ({
      charts: state.charts.map((chart) =>
        chart.id === chartId ? { ...chart, sectionOrder } : chart,
      ),
    }));
  },

  moveSectionUp: (chartId, sectionIndex) => {
    const chart = get().getChart(chartId);
    if (!chart) return;

    // Get current order or create default order
    const currentOrder =
      chart.sectionOrder || get().getDefaultSectionOrder(chartId);

    if (sectionIndex > 0 && sectionIndex < currentOrder.length) {
      const newOrder = [...currentOrder];
      // Swap with previous section
      [newOrder[sectionIndex - 1], newOrder[sectionIndex]] = [
        newOrder[sectionIndex],
        newOrder[sectionIndex - 1],
      ];

      // Also swap the corresponding heights
      const currentHeights = chart.sectionHeights || {};
      const newHeights = { ...currentHeights };

      // Get the heights for the sections being swapped
      const height1 = currentHeights[sectionIndex - 1];
      const height2 = currentHeights[sectionIndex];

      // Swap the heights
      if (height1 !== undefined) newHeights[sectionIndex] = height1;
      else delete newHeights[sectionIndex];

      if (height2 !== undefined) newHeights[sectionIndex - 1] = height2;
      else delete newHeights[sectionIndex - 1];

      // Update both order and heights
      get().setSectionOrder(chartId, newOrder);
      get().setSectionHeights(chartId, newHeights);
    }
  },

  moveSectionDown: (chartId, sectionIndex) => {
    const chart = get().getChart(chartId);
    if (!chart) return;

    // Get current order or create default order
    const currentOrder =
      chart.sectionOrder || get().getDefaultSectionOrder(chartId);

    if (sectionIndex >= 0 && sectionIndex < currentOrder.length - 1) {
      const newOrder = [...currentOrder];
      // Swap with next section
      [newOrder[sectionIndex], newOrder[sectionIndex + 1]] = [
        newOrder[sectionIndex + 1],
        newOrder[sectionIndex],
      ];

      // Also swap the corresponding heights
      const currentHeights = chart.sectionHeights || {};
      const newHeights = { ...currentHeights };

      // Get the heights for the sections being swapped
      const height1 = currentHeights[sectionIndex];
      const height2 = currentHeights[sectionIndex + 1];

      // Swap the heights
      if (height1 !== undefined) newHeights[sectionIndex + 1] = height1;
      else delete newHeights[sectionIndex + 1];

      if (height2 !== undefined) newHeights[sectionIndex] = height2;
      else delete newHeights[sectionIndex];

      // Update both order and heights
      get().setSectionOrder(chartId, newOrder);
      get().setSectionHeights(chartId, newHeights);
    }
  },

  setSectionHeights: (chartId, sectionHeights) => {
    set((state) => ({
      charts: state.charts.map((chart) =>
        chart.id === chartId ? { ...chart, sectionHeights } : chart,
      ),
    }));
  },

  updateSectionHeight: (chartId, sectionIndex, newHeight) => {
    const chart = get().getChart(chartId);
    if (!chart) return;

    const currentHeights = chart.sectionHeights || {};
    const updatedHeights = {
      ...currentHeights,
      [sectionIndex]: newHeight,
    };

    get().setSectionHeights(chartId, updatedHeights);
  },
});
